module.exports = __webpack_public_path__ + "img/slide_5.3e242130.jpg";